import { NETWORK_CONNECTIVITY as SERVICE_WORKER_NETWORK_CONNECTIVITY } from '../../../../ServiceWorker/src/constants/network-connectivity.constants';

export { SERVICE_WORKER_NETWORK_CONNECTIVITY as NETWORK_CONNECTIVITY };
